module.exports = __webpack_public_path__ + "src/app/assets/images/buildo.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/buildo.png
// module id = 620
// module chunks = 0